import { FilingCaseType, FilingType, PndStatus, PndType, TransactionType } from "@/enums/enums";
import { MerchantDetail } from "../merchant/merchantModel";
import { UserInfoModel } from "../user/userModel";
import { CredentialModel, ElementDefaultModel, ElementUserApproveModel, ElementUserCreateModel } from "./documentModel";
import { SettingPndDocumentTemplateModel } from "./settingDocumentTemplate";
import { WhtCertificateItemModel, WhtCertificateModel } from "./witholdingTaxDocumentModal";

export class PndDocumentModel {
  pndId!: number;
  pndNumber!: string;
  pndType!: PndType;
  pndDate!: Date;
  subTotal!: number;
  whtTotal!: number;
  surchargeAmount!: number;
  netAmount!: number;
  countWhtCertificate!: number;
  status!: PndStatus;
  filingType!: FilingType;
  filingRound!: number;
  filingCaseType!: FilingCaseType;
  isFiled!: boolean;
  isClosingEntry!: boolean;
  isPaid!: boolean;
  isDeleted!: boolean;
  createdDateTime!: Date;
  createdUser!: UserInfoModel;
  updatedDateTime!: Date;
  updatedUser!: UserInfoModel;
  approvedDateTime!: Date;
  approvedUser!: UserInfoModel;
  merchant!: MerchantDetail;
  tags!: Array<string>;
  whtCertificateModelList!: Array<WhtCertificateModel>;
}

export class PndDocumentDetailModel {
  data!: PndDocumentModel;
  version!: number;
}

export class PndOnlineViewModel {
  document!: PndDocumentDetailModel;
  template!: SettingPndDocumentTemplateModel;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  headerOptionType!: number;
  credential!: CredentialModel;
}

export class PndDocumentTemplateModel {
  transactionType!: TransactionType;
  pndType!: PndType;
  pndNumber!: string;
  taxPeriodDate!: Date;
  filingType!: FilingType;
  times!: number;
  subTotal!: number;
  whtTotal!: number;
  surchargeAmount!: number;
  netAmount!: number;
  filingCaseType!: FilingCaseType;
  countWhtCertificate!: number;
  merchant!: MerchantDetail;
  userCreate!: ElementUserCreateModel;
  userApprove!: ElementUserApproveModel;
  merchantStampUrl!: ElementDefaultModel;
  whtCertificateModelList!: Array<WhtCertificateModel>;
  isDeleted!: boolean;
}

export class WhtCertificateItemForPaperModel {
  whtCertificateOne!: WhtCertificateItemModel;
  whtCertificateTwo!: WhtCertificateItemModel;
  whtCertificateThree!: WhtCertificateItemModel;
  whtCertificateFour!: WhtCertificateItemModel;
  whtCertificateFive!: WhtCertificateItemModel;
  whtCertificateSix!: WhtCertificateItemModel;

  constructor() {
    this.whtCertificateOne = new WhtCertificateItemModel();
    this.whtCertificateOne = new WhtCertificateItemModel();
    this.whtCertificateOne = new WhtCertificateItemModel();
    this.whtCertificateOne = new WhtCertificateItemModel();
    this.whtCertificateOne = new WhtCertificateItemModel();
  }
}
